module.exports = __webpack_public_path__ + "static/sol5-96eae43c8b14459bdf1c77fda8d0dec3.png";